module.exports = __webpack_public_path__ + "images/buell_small2c4d93031ce9d18cd931a0596382342e.png";